import { plainToClass } from 'class-transformer';
import {
  API_CITY_FIND_ALL,
  API_CITY_FIND_ONE,
  API_CITY_CREATE,
  API_CITY_UPDATE,
  API_CITY_DELETE
} from '../api.routes';
import { BaseApi } from './base.api';
import { CityDto } from '../dto';
import { FindAllResponse } from '../types';

export class CityApi extends BaseApi {
  /**
   * Find all
   */
  public findAll(params): Promise<FindAllResponse<CityDto>> {
    return this.httpClient
      .get(API_CITY_FIND_ALL, { params })
      .then(({ data }) => {
        return {
          ...data,
          items: plainToClass(CityDto, data.items)
        };
      });
  }

  /**
   * Find one
   * @param uuid
   */
  public findOne(uuid: string): Promise<CityDto> {
    return this.httpClient
      .get(API_CITY_FIND_ONE, { pathParams: { uuid } })
      .then(({ data }) => {
        return plainToClass(CityDto, data);
      });
  }

  /**
   * Create
   * @param data
   */
  public create(data): Promise<CityDto> {
    return this.httpClient.post(API_CITY_CREATE, data).then(({ data }) => {
      return plainToClass(CityDto, data);
    });
  }

  /**
   * Update
   * @param data
   */
  public update(data): Promise<CityDto> {
    return this.httpClient.put(API_CITY_UPDATE, data).then(({ data }) => {
      return plainToClass(CityDto, data);
    });
  }

  /**
   * Delete
   * @param uuid
   */
  public delete(uuid): Promise<void> {
    return this.httpClient.delete(API_CITY_DELETE, {
      pathParams: { uuid }
    });
  }
}
